import * as React from "react";
import { Button, Select, message } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface IAllocationOrderProps {
  orderNo: any;
  getUser: any;
  searchOrder: any;
  // 分配订单
  allotOrder: any;
  share: any;
}

// 分配订单
class AllocationOrder extends React.Component<IAllocationOrderProps, any> {
  state = {
    userId: null
  };

  constructor(props: IAllocationOrderProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getUser();
  }

  renderOption = () => {
    const share = this.props.share;
    let list: any = [];
    if (share["user"]) {
      const user = share["user"];
      for (let i = 0; i < user.length; i++) {
        // 排除已停用的客服
        if (user[i].isLock === "yes") continue;
        list.push(
          <Option key={i} value={user[i].id}>
            {user[i].name}
          </Option>
        );
      }
    }
    return list;
  };

  filterOption = (input, option) => {
    return (
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  };

  onChange = value => {
    console.log(`selected ${value}`);
    this.setState({
      userId: value
    });
  };

  allotOrder = () => {
    if (this.props.orderNo.length > 0 && this.state.userId) {
      this.props.allotOrder({
        ids: this.props.orderNo.join(),
        uId: this.state.userId,
        callback: res => {
          if (res && res.error) {
            message.error(res.res.msg);
          } else {
            message.success("分配订单成功");
            this.props.searchOrder();
          }
        }
      });
    } else {
      message.config({
        top: 100,
        duration: 2,
        maxCount: 1
      });
      message.warning("请选择订单和客服");
    }
  };

  render() {
    const buttonStyle = {
      backgroundColor: "#2b9fbd",
      borderColor: "#2b9fbd"
    };
    return (
      <div className="button-select">
        <Button.Group size="default" className="button-select-group">
          <Select
            placeholder="请选择客服"
            allowClear
            size="default"
            style={{ width: 110 }}
            showSearch
            onChange={this.onChange}
            filterOption={this.filterOption}
          >
            {this.renderOption()}
          </Select>
          <Button type="primary" style={buttonStyle} onClick={this.allotOrder}>
            分配订单
          </Button>
        </Button.Group>
      </div>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    getUser: dispatch.selectorSource.getUser,
    allotOrder: dispatch.orderInfo.allotOrder
  };
};

export default connect(
  mapState,
  mapDispatch
)(AllocationOrder);
